/**
 * Footer-Hinweis „We #StandWithUkraine“.
 *
 * Badge in der unteren Footer-Reihe neben „Blog“: dunkle Pille mit Herz
 * in Ukraine-Flaggenfarben (oben Blau, unten Gelb) und Link zur
 * Nothilfe-Seite der Aktion Deutschland Hilft in einem neuen Tab.
 */

const UKRAINE_HREF =
  "https://www.aktion-deutschland-hilft.de/spenden-nothilfe-ukraine/";

export function StandWithUkraineBadge() {
  return (
    <a
      href={UKRAINE_HREF}
      target="_blank"
      rel="noreferrer noopener"
      aria-label="We #StandWithUkraine – Spendenaktion Nothilfe Ukraine (öffnet in neuem Tab)"
      className="inline-flex items-center gap-2 rounded-full border border-primary-foreground/25 bg-primary-foreground/10 px-3 py-1.5 font-display text-[13px] font-extrabold tracking-wide text-primary-foreground transition-colors hover:border-brand-button hover:text-brand-button focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-button focus-visible:ring-offset-2 focus-visible:ring-offset-primary"
    >
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
        className="h-4 w-4 shrink-0"
      >
        <defs>
          <clipPath id="standwithukraine-heart">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
          </clipPath>
        </defs>
        <g clipPath="url(#standwithukraine-heart)">
          <rect x="0" y="3" width="24" height="9.2" fill="#005BBB" />
          <rect x="0" y="12.2" width="24" height="9.5" fill="#FFD500" />
        </g>
      </svg>
      <span>We #StandWithUkraine</span>
    </a>
  );
}
